// Module
var code = `<a>{{ richDropdown.item.needsTranslated ? (richDropdown.item[richDropdown.options.selectedTitleKey || richDropdown.options.titleKey || 'title'] | translate) : richDropdown.item[richDropdown.options.selectedTitleKey || richDropdown.options.titleKey || 'title'] }}</a>`;
// Exports
export default code;